<template>
  <div class="identityverificationv2">
    <div class="container">
      <!-- Content here -->

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <h5>會員資料驗證</h5>
              <br />
              <p>
                身分證實名認證（請務必正確填寫以下資訊，本人身份查核之用，謝謝！）
              </p>
            </div>
            <div class="col-12 col-lg-6 mt-1">
              <br />身份證實名認證範例： <br />1. 發證日期 <br />2. 發證地點
              <br />3. 領補換類別 <br />4. 統一編號(身份證字號)
            </div>
            <div class="col-12 col-lg-6 mt-1">
              <img
                src="https://i.imgur.com/kvNOnBc.jpg"
                class="identityimage"
                alt
              />
            </div>

            <div class="col-12 mp-3">
              <div>
                <b-form
                  inline
                  @submit="onSubmit"
                  @reset="onReset"
                  v-if="formShow"
                >
                  <div class="col-6 pt-3">
                    <p>真實姓名:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-name"
                      label
                      label-for="input-name"
                    >
                      <b-form-input
                        id="input-name"
                        v-model="form.name"
                        required
                        placeholder="真實姓名"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 col-md-3 pt-3">
                    <p>發證日期:</p>
                  </div>

                  <div class="col-6 col-md-3 pt-3">
                    <label class="mr-sm-2" for="inline-form-custom-select-y"
                      >年</label
                    >
                    <b-form-select
                      required
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="null"
                      :options="form.selectOptionYY"
                      v-model="form.selectYY"
                      id="inline-form-custom-select-y"
                    >
                      <option slot="first" :value="null">請選擇...</option>
                    </b-form-select>
                  </div>

                  <div class="col-6 col-md-3 pt-3">
                    <label class="mr-sm-2" for="inline-form-custom-select-m"
                      >月</label
                    >
                    <b-form-select
                      required
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="null"
                      :options="form.selectOptionMM"
                      v-model="form.selectMM"
                      id="inline-form-custom-select-m"
                    >
                      <option slot="first" :value="null">請選擇...</option>
                    </b-form-select>
                  </div>

                  <div class="col-6 col-md-3 pt-3">
                    <label class="mr-sm-2" for="inline-form-custom-select-d"
                      >日</label
                    >
                    <b-form-select
                      required
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="null"
                      :options="form.selectOptionDD"
                      v-model="form.selectDD"
                      id="inline-form-custom-select-d"
                    >
                      <option slot="first" :value="null">請選擇...</option>
                    </b-form-select>
                  </div>

                  <div class="col-6 pt-3">
                    <p>發證地點:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <!-- <label class="mr-sm-2" for="inline-form-custom-select-d">日</label> -->
                    <b-form-select
                      required
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="null"
                      :options="form.selectOptionLocal"
                      v-model="form.selectLocal"
                      id="inline-form-custom-select-local"
                    >
                      <option slot="first" :value="null">請選擇...</option>
                    </b-form-select>
                  </div>

                  <div class="col-6 pt-3">
                    <p>領補發類別:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <!-- <label class="mr-sm-2" for="inline-form-custom-select-d">日</label> -->
                    <b-form-select
                      required
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="null"
                      :options="form.selectOptionReason"
                      v-model="form.selectReason"
                      id="inline-form-custom-select-reason"
                    >
                      <option slot="first" :value="null">請選擇...</option>
                    </b-form-select>
                  </div>

                  <div class="col-6 pt-3">
                    <p>身份證字號:</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-id"
                    >
                      <b-form-input
                        id="input-id"
                        v-model="form.id"
                        required
                        placeholder="身份證字號"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-4 pt-3" v-if="manualValid == false">
                    <p>請輸入驗證碼:</p>
                  </div>
                  <div class="col-4 pt-3" v-if="manualValid == false">
                    <b-form-group
                      id="input-group-captchaInput"
                      label
                      label-for="input-captchaInput"
                    >
                      <b-form-input
                        id="input-captchaInput"
                        v-model="form.captchaInput"
                        required
                        placeholder="驗證碼"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-4 pt-3" v-if="manualValid == false">
                    <img
                      v-bind:src="captchaImage"
                      class="captchaimage"
                      @error="imageLoadError"
                      alt
                    />
                    <b-button variant="success" size="sm" @click="getCaptcha()"
                      >產生驗證碼</b-button
                    >
                  </div>

                  <div class="col-6 pt-3">
                    <p>綁定銀行帳戶(數字):</p>
                  </div>
                  <div class="col-6 pt-3">
                    <b-form-group
                      id="input-group-id"
                      label
                      label-for="input-id"
                    >
                      <b-form-input
                        id="input-id"
                        v-model="form.bankaccount"
                        required
                        placeholder="銀行帳戶"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-6 pt-3">
                    <b-button type="reset" block variant="danger"
                      >重新填寫</b-button
                    >
                  </div>

                  <div class="col-6 pt-3">
                    <b-button type="submit" block variant="primary"
                      >填寫完成</b-button
                    >
                  </div>
                </b-form>
                <br />
                <b-alert show variant="danger" style="text-align: left">
                  代購幫為了配合政府機關以及避免第三方詐騙和被有心人士利用做為洗錢管道，
                  <br />
                  <br />您所填寫的身分證資料僅用於內政部連線及代購幫認證使用。
                  <br />
                  <br />預防三方詐騙的風險，我們將綁定您的銀行帳戶確認付款
                  <br />
                  <br />每日驗證錯誤達兩次後，此身分證資料將被鎖定24小時無法再次進行認證，提交送出前請仔細確認資料正確性，謝謝。
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog />
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<style type="text/css">
.identityimage {
  width: 100%;
  height: 100%;
}
.captchaImage {
  width: 240px;
  height: 100px;
}
</style>

<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'identityverificationv2',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      prodDatas: '',
      orderDatas: '',
      categoryViews: '',
      displayViews: '',
      captchaImage: '',
      captchaKey: '',
      form: {
        name: '',
        bankaccount: '',
        id: '',
        selectYY: '',
        selectOptionYY: {
          110: '110',
          109: '109',
          108: '108',
          107: '107',
          106: '106',
          105: '105',
          104: '104',
          103: '103',
          102: '102',
          101: '101',
          100: '100',
          99: '99',
          98: '98',
          97: '97',
          96: '96',
          95: '95',
          94: '94',
        },
        selectMM: '',
        selectOptionMM: {
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          7: '7',
          8: '8',
          9: '9',
          10: '10',
          11: '11',
          12: '12',
        },
        selectDD: '',
        selectOptionDD: {
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          7: '7',
          8: '8',
          9: '9',
          10: '10',
          11: '11',
          12: '12',
          13: '13',
          14: '14',
          15: '15',
          16: '16',
          17: '17',
          18: '18',
          19: '19',
          20: '20',
          21: '21',
          22: '22',
          23: '23',
          24: '24',
          25: '25',
          26: '26',
          27: '27',
          28: '28',
          29: '29',
          30: '30',
          31: '31',
        },
        selectLocal: '',
        selectOptionLocal: {
          10001: '北縣',
          65000: '新北市',
          10002: '宜縣',
          10003: '桃縣',
          10004: '竹縣',
          10005: '苗縣',
          10006: '中縣',
          10007: '彰縣',
          10008: '投縣',
          10009: '雲縣',
          10010: '嘉縣',
          10011: '南縣',
          10012: '高縣',
          10013: '屏縣',
          10014: '東縣',
          10015: '花縣',
          10016: '澎縣',
          10017: '基市',
          10018: '竹市',
          10020: '嘉市',
          '09007': '連江',
          '09020': '金門',
          63000: '北市',
          64000: '高市',
          66000: '中市',
          67000: '南市',
          68000: '桃市',
        },
        selectReason: '',
        selectOptionReason: {
          1: '初發',
          2: '補發',
          3: '換發',
        },
      },
      formShow: true,
      imageErrorCount: 0,
      manualValid: false,
    }
  },
  watch: {},
  methods: {
    onSubmit(evt) {
      const vm = this
      evt.preventDefault()
      // alert(JSON.stringify(vm.form));
      vm.verifyGovIdentity()
    },
    onReset(evt) {
      const vm = this
      evt.preventDefault()
      // Reset our form values
      vm.form.id = ''
      vm.form.name = ''

      // Trick to reset/clear native browser form validation state
      vm.formShow = false
      vm.$nextTick(() => {
        vm.formShow = true
      })
    },
    checkUnChatbotSignin: function () {
      const vm = this
      console.log(decodeURI(vm.$route.query.userId))
      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined ||
        localStorage.userImage == undefined ||
        localStorage.userName == undefined
      ) {
        if (vm.userId.length == 0) {
          vm.$modal.show('dialog', {
            title: '🙋您尚未登入FB會員',
            text: '快使用FB登入享受快速服務⚡',
            buttons: [
              {
                title: '關閉',
              },
              {
                title: '👉用FB登入',
                handler: () => {
                  window.location = 'https://m.me/2266831083395361'
                },
              },
            ],
          })
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getCaptcha: function () {
      const vm = this
      vm.isLoading = true
      let formData = {
        userAgent: navigator.userAgent,
        // navigator.userAgent
      }
      axios
        .post(vm.apiUrl + 'GetGovCaptchaImage', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          var data = response.data

          vm.captchaImage = data.url
          vm.captchaKey = data.key
          vm.$forceUpdate()
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '驗證碼拿取失敗: ' + error,
            type: 'error',
          })
        })
    },
    imageLoadError: function () {
      const vm = this
      vm.imageErrorCount++
      if (vm.imageErrorCount >= 2) {
        vm.manualValid = true
        // vm.$toast.open({
        //   message: "Image failed to load " + vm.imageErrorCount,
        //   type: "error"
        // });
      }
    },
    verifyGovIdentity: function () {
      const vm = this
      vm.isLoading = true
      let formData = {
        idnum: vm.form.id,
        applyTWY: vm.form.selectYY,
        applyMM: vm.form.selectMM,
        applyDD: vm.form.selectDD,
        siteId: vm.form.selectLocal,
        applyReason: vm.form.selectReason,
        captchaKey: vm.captchaKey,
        captchaInput: vm.form.captchaInput,
      }
      if (vm.manualValid) {
        vm.$toast.open({
          message:
            '我們將會在3天內為您手動驗證身份，驗證成功將會主動推播您! 有任何問題都可以跟我們客服反應!',
          type: 'success',
        })
        vm.addProfile(0)
        vm.sendBidFbMessageConsumer(localStorage.userId, 'manual_verify')
        vm.$router.push('validIdentitymanual')
      } else {
        axios
          .post(vm.apiUrl + 'VerifyGovIdentity', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            // console.log(data);
            if (data.code == 200) {
              vm.addProfile(1)
            } else {
              if (vm.manualValid) {
                vm.$toast.open({
                  message:
                    '我們將會在3天內為您手動驗證身份，驗證成功將會主動推播您! 有任何問題都可以跟我們客服反應!',
                  type: 'success',
                })
                vm.sendBidFbMessageConsumer(
                  localStorage.userId,
                  'manual_verify'
                )
                vm.getCaptcha()
                vm.addProfile(0)
              } else {
                vm.$toast.open({
                  message: '驗證失敗: ' + data.message,
                  type: 'error',
                })
                vm.getCaptcha()
                vm.addProfile(0)
              }
            }
            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            if (vm.manualValid) {
              vm.$toast.open({
                message:
                  '我們將會在3天內為您手動驗證身份，驗證成功將會主動推播您! 有任何問題都可以跟我們客服反應!',
                type: 'success',
              })
              vm.getCaptcha()
              vm.addProfile(0)
            } else {
              vm.$toast.open({
                message: '驗證失敗: ' + error,
                type: 'error',
              })
              vm.getCaptcha()
              vm.addProfile(0)
            }
          })
      }
    },
    addProfile: function (isValid) {
      const vm = this
      vm.isLoading = true
      let userId = localStorage.userId
      let userNickName = localStorage.userName
      let userImage = localStorage.userImage

      if (userId == undefined) {
        userId = vm.userId
        userNickName = vm.userName
        userImage = vm.userImage
      }

      let formData = {
        userId: userId,
        userNickName: userNickName,
        userName: vm.form.name,
        userPhone: '',
        userImage: userImage,
        userAddress: '',
        userMapInfo: '',
        idnum: vm.form.id,
        applyTWY: vm.form.selectYY,
        applyMM: vm.form.selectMM,
        applyDD: vm.form.selectDD,
        siteId: vm.form.selectLocal,
        applyReason: vm.form.selectReason,
        captchaKey: vm.captchaKey,
        captchaInput: vm.form.captchaInput,
        isValid: isValid,
        bankInfo: {
          bankaccount: vm.form.bankaccount,
        },
      }
      axios
        .post(vm.apiUrl + 'AddProfile', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function () {
          // var data = response.data;
          // console.log(data);
          if (isValid == 1) {
            vm.sendBidFbMessageConsumer(localStorage.userId, 'auto_verify')
            vm.$router.push('valididentity')
          }

          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '驗證失敗: ' + error,
            type: 'error',
          })
        })
    },
    sendBidFbMessageConsumer: function (userId, tempType) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: tempType,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplate', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '驗證成功發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
  },
  mounted() {
    const vm = this

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    if (vm.$route.query.accountNotExist == 1) {
      vm.$modal.show('dialog', {
        title: '🙋您尚未實名驗證，請先準備好身分證!!',
        text: '在您使用海外所有代買幫提供的服務之前，您需要先完成身份驗證，日期是身分證發照日期，驗證碼有英文與數字大小寫要正確喔!',
        buttons: [
          {
            title: '知道了，關閉視窗',
          },
        ],
      })
    }

    vm.$modal.show('dialog', {
      title: '🙋請先準備好身分證!',
      text: '日期是身分證發照日期，驗證碼有英文與數字大小寫要正確喔!',
      buttons: [
        {
          title: '知道了，關閉視窗',
        },
      ],
    })

    vm.checkUnChatbotSignin()
    vm.getCaptcha()
  },
}
</script>
